import {ApiClient, Country} from '@hconnect/apiclient'
import {QueryFunction, useQuery} from '@tanstack/react-query'
import {AxiosError, AxiosInstance} from 'axios'

const countryConfigurationFetcher =
  (api: AxiosInstance): QueryFunction<Country | null> =>
  async ({queryKey}) => {
    const [base, endpoint, country] = queryKey

    if (!country) {
      return null
    }

    // This is public endpoint
    const response = await api.get<Country>(`/${base}/${endpoint}/${country}`)
    return response.data
  }

export const useCountryConfiguration = (country?: string | null) => {
  return useQuery<Country | null, AxiosError>({
    queryKey: ['configurations', 'countries', country],
    queryFn: countryConfigurationFetcher(ApiClient.axiosInstance),
    retry: false
  })
}
